import React from 'react';
import { Card } from './ui/card';
import { CheckCircle2, Activity } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';

const Training = ({ data }) => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <div>
            <div className="flex items-center mb-4">
              <Activity className="h-8 w-8 text-green-500 mr-3" />
              <span className="text-green-500 font-bold uppercase tracking-wider text-sm">{t('training.trainingProgram')}</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black mb-6">
              {t('training.eliteLevelTraining')}
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              {data.description}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 mb-8">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                <div className="text-3xl font-black text-green-500">{data.intensity}</div>
                <div className="text-xs text-gray-300 mt-1">{t('training.intensity')}</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                <div className="text-3xl font-black text-green-500">{data.studentsPerGroup}</div>
                <div className="text-xs text-gray-300 mt-1">{t('training.studentsPerGroup')}</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                <div className="text-3xl font-black text-green-500">2x</div>
                <div className="text-xs text-gray-300 mt-1">{t('training.dailySessions')}</div>
              </div>
            </div>
          </div>

          {/* Right: Features List */}
          <Card className="bg-white/5 backdrop-blur-lg border-white/10 p-8">
            <h3 className="text-2xl font-black mb-6 text-white">{t('training.whatsIncluded')}</h3>
            <div className="space-y-3">
              {(t('training.features') || data.features || []).map((feature, index) => (
                <div key={index} className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-200 text-sm">{feature}</span>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Training;